import { INTRANET_PATH_PREFIX } from '@/lib/intranet';

export const AUTH_JWT_COOKIE = 'strapi-jwt';
export const AUTH_USER_COOKIE = 'strapi-user';

export const AUTH_COOKIE_MAX_AGE =
  Number(process.env.AUTH_COOKIE_MAX_AGE) || 60 * 60 * 24 * 7; // 7 days

export const LEGACY_PUBLIC_AUTH_PATHS = [
  '/auth/login',
  '/auth/signup',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/confirm-email',
  '/area-personale',
] as const;

export type AuthUser = {
  id: number;
  username: string;
  email: string;
  confirmed?: boolean;
  blocked?: boolean;
  role?: {
    id: number;
    name: string;
    type: string;
  } | null;
};

export function isLegacyPublicAuthPath(pathname: string): boolean {
  return LEGACY_PUBLIC_AUTH_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

/** Prevent open redirects — only allow same-origin relative paths. */
export function sanitizeCallbackUrl(
  callbackUrl: string | null | undefined,
  fallback = '/',
): string {
  if (!callbackUrl) return fallback;

  try {
    const decoded = decodeURIComponent(callbackUrl);
    if (!decoded.startsWith('/') || decoded.startsWith('//')) {
      return fallback;
    }
    return decoded;
  } catch {
    return fallback;
  }
}

export function sanitizeIntranetCallback(
  callbackUrl: string | null | undefined,
  linkPrefix: string,
): string {
  const fallback = linkPrefix || '/';
  if (!callbackUrl) return fallback;

  try {
    const decoded = decodeURIComponent(callbackUrl);
    if (!decoded.startsWith('/') || decoded.startsWith('//')) {
      return fallback;
    }

    if (linkPrefix) {
      if (decoded === linkPrefix || decoded.startsWith(`${linkPrefix}/`)) {
        return decoded;
      }

      if (isLegacyPublicAuthPath(decoded)) {
        return `${linkPrefix}${decoded}`;
      }

      return linkPrefix;
    }

    if (
      decoded === INTRANET_PATH_PREFIX ||
      decoded.startsWith(`${INTRANET_PATH_PREFIX}/`)
    ) {
      return decoded.slice(INTRANET_PATH_PREFIX.length) || '/';
    }

    return sanitizeCallbackUrl(decoded, fallback);
  } catch {
    return fallback;
  }
}
